import { getErrorMessage } from '@/utils/error.utils';
import type { Attributes } from './logger-types';

export function extractErrorAttributes(value: unknown): Attributes {
  if (value instanceof Error) {
    const attrs: Attributes = { 'exception.type': value.name, 'exception.message': value.message };
    if (value.stack) attrs['exception.stacktrace'] = value.stack;
    return attrs;
  }

  if (value !== null && typeof value === 'object') {
    const obj = value as Record<string, unknown>;
    const attrs: Attributes = {
      'exception.type': typeof obj.name === 'string' ? obj.name : 'ApiError',
      'exception.message': getErrorMessage(value),
    };
    if (typeof obj.stack === 'string') attrs['exception.stacktrace'] = obj.stack;
    if (typeof obj.status === 'number') attrs['http.status_code'] = obj.status;
    if (typeof obj.code === 'string') attrs['error.code'] = obj.code;
    return attrs;
  }

  return { 'exception.message': getErrorMessage(value) };
}
